import { Deserializable } from '../protocols/deserializable';

export class InvestmentInstructionSubmissionAffectedAccount implements Deserializable {
  public accountId!: number;
  public employerName?: string | null;
  public governingJurisdiction?: string | null;

  public onDeserialize() {}
}
